export const priorityRenderer = (priority = 1) => {
  switch (priority) {
    case 1:
      return 'احتیاط مصرف';
    case 2:
      return 'متضاد';
    default:
      return 'کاملا متضاد';
  }
};
